import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BotService } from 'src/app/core/services/bot.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { DateFormatService } from 'src/app/core/services/date-format.service';
import { UserService } from 'src/app/core/services/user.service';
import { UserInterface } from 'src/app/models/user.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'globot-conversation-cards',
  templateUrl: './conversation-cards.component.html',
  styleUrls: ['./conversation-cards.component.scss'],
})
export class ConversationCardsComponent implements OnInit {
  @Input() records: any[] = [];
  @Output() chatHistorySelected = new EventEmitter<any>();
  private subscription: Subscription = new Subscription();
  botId = '';
  selectedCard!: string;
  user: UserInterface | undefined = undefined;
  urlProfile: string = '';
  constructor(
    private botService: BotService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private ss: SpinnerService,
    private readonly userService: UserService,
    private cd: ChangeDetectorRef,
    private dateFormatService: DateFormatService
  ) {
    this.botId = this.aRoute.snapshot.paramMap.get('id') ?? '';
    const sections = this.router.routerState.snapshot.url.split('/');
    this.botId = sections[3];
  }
  ngOnInit(): void {
    this.subscription.add(
      this.userService.url$.subscribe((newUrl) => {
        this.urlProfile = newUrl;
        this.updateUserPicture(newUrl);
      })
    );
  }

  getDateUtc(date: any) {
    return this.dateFormatService.formatRelativeDateUtc(date);
  }

  /**
   * GLOB-1887: la card muestra la fecha del último mensaje real. `updated_at` no sirve
   * porque cualquier escritura sobre la conversación (procesamiento CRM, marcado de
   * leído, backfills) lo empuja a "ahora", y las conversaciones antiguas terminaban
   * etiquetadas como "Hoy". Los fallbacks cubren la ventana de despliegue en que el
   * backend todavía no envía `last_message_at`.
   */
  getRecordDate(record: any): string {
    return this.getDateUtc(record.last_message_at || record.updated_at || record.created_at);
  }

  getFirstPart(sender_id: string): string {
    return sender_id.split(';')[0];
  }

  /**
   * GLOB-1888: `chatHistory` puede llegar vacío (conversación sin mensajes) o nulo
   * (el backend respondía 204, que Angular entrega como `null`). Siempre se emite una
   * lista para que el panel de detalle pinte su estado vacío en vez de quedar en
   * blanco, y el error también se emite en vez de dejar la selección colgada.
   */
  getChatHistory = (record: any) => {
    this.selectedCard = record.correlation_id;
    this.botService.getChatHistory(this.botId, record.correlation_id).subscribe({
      next: (chatHistory) => {
        this.chatHistorySelected.emit({ record, chatHistory: chatHistory ?? [] });
        this.updateNewMessageStatus(record.correlation_id);
      },
      error: () => {
        this.chatHistorySelected.emit({ record, chatHistory: [] });
      },
    });
  };
  getDisplayName(name: string | null): string {
    return name === null || name === 'N/A' ? 'Anónimo' : name;
  }

  getChannelIcon(channel: string): string {
    const map: Record<string, string> = {
      WEB: 'pi pi-globe',
      WHATSAPP: 'pi pi-whatsapp',
      INSTAGRAM: 'pi pi-instagram',
      MESSENGER: 'pi pi-facebook',
      FACEBOOK: 'pi pi-facebook',
      DISCORD: 'pi pi-discord',
      SLACK: 'pi pi-slack',
    };
    return map[(channel || '').toUpperCase()] ?? 'pi pi-comments';
  }

  getChannelColor(channel: string): string {
    const map: Record<string, string> = {
      WEB: '#3B82F6',
      WHATSAPP: '#22C55E',
      INSTAGRAM: '#EC4899',
      MESSENGER: '#0084FF',
      FACEBOOK: '#1877F2',
      DISCORD: '#5865F2',
      SLACK: '#E01E5A',
    };
    return map[(channel || '').toUpperCase()] ?? '#6D5BE6';
  }

  isChannelIconVisible(channel: string): boolean {
    return ['WHATSAPP', 'MESSENGER', 'INSTAGRAM', 'WEB'].includes(channel);
  }
  private updateUserPicture(newUrl: string): void {
    if (this.user) {
      this.user.picture = newUrl;
    }
    this.cd.detectChanges();
  }
  trackByCorrelationId(_index: number, record: any): string {
    return record.correlation_id;
  }

  updateNewMessageStatus(correlation_id: string) {
    const record = this.records.find((r) => r.correlation_id === correlation_id);
    if (record) {
      record.new_message = false;
    }
  }
}
